import variables from 'common/config/variables';
import { getScalablePixel } from 'common/utils';
import GlobalStyle from 'common/utils/GlobalStyle';
import { hexToRGB } from 'common/utils/helpers';

GlobalStyle.inject`
.skeleton-loader {
    background-color: ${hexToRGB(variables.color_grey_70, 0.6)};
    overflow: hidden;
    position: relative;
    margin-bottom: ${getScalablePixel(25)}px;
    flex-shrink: 0;
    z-index: 0;
    -webkit-transform: translateZ(0);

    &.margin {
        margin: ${getScalablePixel(8)}px;
    }

    &.round {
        border-radius: ${getScalablePixel(8)}px;
        -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
    }


    @keyframes skeleton-shimmer {
        0% {
            transform: translate3d(-100%, 0, 0);
        }
        100% {
            transform: translate3d(100%, 0, 0);
        }
    }

    .shimmer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        background: 
            linear-gradient(90deg,
            rgba(0, 0, 0, 0) 0%,
            ${variables.color_grey_70} 40%,
            ${variables.color_grey_70} 58%,
            rgba(0, 0, 0, 0) 100%);
        background-size: 100%;
        animation: skeleton-shimmer 2.2s cubic-bezier(0.22, 0.61, 0.36, 1) infinite forwards;
    }
}
`;
